/**
 * Loading spinner component.
 */

export function Spinner() {
  return <div className="spinner" />;
}

export function LoadingOverlay() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '48px' }}>
      <Spinner />
    </div>
  );
}
